import { feature as liveChatFeature } from '@central-products/live-chat-flow';
import { isNative, isIos, isAndroid } from '../../utils';
import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';
import { subscribe } from '@wh/message-bus';

function waitForVisitorId(maxRetries) {
  const oldVal = window.utag && window.utag.dle_visitor_id;
  return new Promise((resolve) => {
    let count = 0;
    const int = setInterval(() => {
      const newVal = window.utag && window.utag.dle_visitor_id;
      if (newVal !== oldVal || count >= maxRetries) {
        clearInterval(int);
        resolve(newVal);
        return;
      }
      count++;
    }, 500);
  });
}

function syncAudiencesViaVisitorService(bootstrapperFeatures, params) {
  const CALLBACK_NAME = 'liveChatPluginCb';
  window.kraken[CALLBACK_NAME] = function liveChatPluginCb(data) {
    if (!data.audiences) {
      return;
    }
    const audiences = Object.values(data.audiences);
    bootstrapperFeatures['live-chat-flow'].setAudiences(audiences);
  };

  bootstrapperFeatures['account-info'].onStateChanged(async ({ state }) => {
    if (state !== 'ACCOUNT_INFO_EXISTS') {
      return;
    }

    const visitorId = await waitForVisitorId(params.visitorIdMaxRetries);

    await fetch(params.tealiumInitUrl.replace('$(visitorId)', visitorId));

    const script = document.createElement('script');
    script.onload = function onload() {
      script.parentNode.removeChild(script);
    };
    script.src =
      params.visitorServiceUrl.replace('$(visitorId)', visitorId) +
      `?callback=window.kraken.${CALLBACK_NAME}&rnd=${new Date().getTime()}`;
    document.body.appendChild(script);
  });
}

export const liveChatPlugin = {
  beforeBootstrap({ addBootstrapperFeature, params }) {
    const allowIosNative = params.allowIosNative ?? false;
    const allowAndroidNative = params.allowAndroidNative ?? false;

    if (isNative() && ((isIos() && !allowIosNative) || (isAndroid() && !allowAndroidNative))) {
      return;
    }

    addBootstrapperFeature(liveChatFeature, params);
  },
  postBootstrap({ bootstrapperFeatures, params }) {
    if (!bootstrapperFeatures['live-chat-flow']) return;

    if (params.syncAudiencesViaVisitorService) {
      syncAudiencesViaVisitorService(bootstrapperFeatures, params);
    }

    const triggerChat = bootstrapperFeatures['live-chat-flow'].activateEngagement;
    const errorFallback = (response) => {
      if (response instanceof Error && params.fallbackUrl) {
        window.open(params.fallbackUrl);
      }
    };

    bootstrapperFeatures['account-actions'].onActionRequested(({ actionId, data }) => {
      if (actionId === ACCOUNT_ACTION_IDS.LIVE_CHAT_START) {
        triggerChat(data).then(errorFallback).catch(errorFallback);
      }
    });

    if (params.defaultEngagementName) {
      const DEFAULT_LIVE_CHAT_ENGAGEMENT = { name: params.defaultEngagementName };

      subscribe('live-person.open', () => {
        triggerChat(DEFAULT_LIVE_CHAT_ENGAGEMENT).then(errorFallback).catch(errorFallback);
      });

      subscribe('wh.myAccount.event.footer.request.livePerson', () => {
        triggerChat(DEFAULT_LIVE_CHAT_ENGAGEMENT).then(errorFallback).catch(errorFallback);
      });
    }
  },
};
